import Amount from '../amount/locale/en';
import Cascader from '../cascader/locale/en';
import Chart from '../chart/locale/en';
import DatePicker from '../date-picker/locale/en';
import Day from '../day/locale/en';
import InputIpAddress from '../input-ip-address/locale/en';
import InputIpRange from '../input-ip-range/locale/en';
import InputIp from '../input-ip/locale/en';
import InputSubnet from '../input-subnet/locale/en';
import Layout from '../layout/locale/en';
import LocationPicker from '../location-picker/locale/en';
import Modal from '../modal/locale/en';
import Notification from '../notification/locale/en';
import Pagination from '../pagination/locale/en';
import SelectLocation from '../select-location/locale/en';
import Select from '../select/locale/en';
import Sidebar from '../sidebar/locale/en';
import SuperSearch from '../super-search/locale/en';
import Switch from '../switch/locale/en';
import TabSelect from '../tab-select/locale/en';
import Table from '../table/locale/en';
import Textarea from '../textarea/locale/en';
import PresetDatePicker from '../preset-date-picker/locale/en';
const locale = {
  Amount,
  Cascader,
  Chart,
  DatePicker,
  Day,
  InputIp,
  InputIpAddress,
  InputSubnet,
  InputIpRange,
  Layout,
  LocationPicker,
  Modal,
  Notification,
  Pagination,
  Select,
  SelectLocation,
  Sidebar,
  SuperSearch,
  Switch,
  TabSelect,
  Table,
  Textarea,
  PresetDatePicker
};
export default locale;